// This is another reducer that will get chained into the enhancedLoadingStateReducer. It will re-initialize
// the loadingState values when we change the form being displayed.

export default actionType => (state, action) => {
    if (action.type === actionType) {
        return {
            isLoading: false,
            success: false,
            errors: []
        };
    }

    return state;
};